import { getConstant } from '../utils';

export const getCalculate = getConstant('GET_CALCULATE');
export const getCalculates = getConstant('GET_CALCULATES');
export const removeCalculate = getConstant('REMOVE_CALCULATE');
export const clearCalculate = getConstant('CLEAR_CALCULATE');
export const updateCalculate = getConstant('UPDATE_CALCULATE');
export const addCalculate = getConstant('ADD_CALCULATE');
